import { Box, Link, Text } from '@opendoor/bricks-next';

export interface StateLink {
  name: string;
  slug: string;
  count: number;
}

interface StateLinkListProps {
  states: StateLink[];
}

export const StateLinkList: React.FC<StateLinkListProps> = ({ states }) => {
  if (!states.length) {
    return null;
  }

  return (
    <Box tag="section" aria-label="States with homes for sale" py="$8x" flex={1}>
      <Box px="$4x" mx="auto">
        <Text tag="h2" typography="$headerSmall" mb="$6x">
          States with homes for sale
        </Text>
        <Box
          tag="ul"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
            gap: '1rem',
            listStyle: 'none',
            padding: 0,
            margin: 0,
          }}
        >
          {states
            .filter((state) => state.count > 0)
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((state) => (
              <Box tag="li" key={state.slug}>
                <Link
                  analyticsName="state-directory-link"
                  href={`/homes/state/${state.slug}`}
                  variant="primary"
                >
                  {state.name} ({state.count})
                </Link>
              </Box>
            ))}
        </Box>
      </Box>
    </Box>
  );
};
